import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";
import LiveTVPage from "@/screens/LiveTVPage";

export default function Category({
  latestStoryData = null,
  latestVideoData = null,
  faqData = null,
  storyPageData = null,
}) {
  const isMobileDevice = useIsMobile();

  const metaDesc = {
    title:
      "TAK 360 Live TV: Breaking News, Politics & Top Stories 24x7 LIVE TV Free, Live Streaming Online, Watch TAK 360 Live - NewsTak",
    description:
      "Watch TAK 360 Live TV on NewsTak for real-time breaking news, political updates and top stories from India. Get 24x7 live coverage anytime anywhere.",
    keywords: `TAK 360 Live TV, Tak Live News, TAK 360 News Channel, Live TV News India, Free Live Streaming Online News Channel, Breaking News Live, Hindi News Live TV, India News Live Streaming, Politics News Live, Today News Live India, Watch Local Live TV Free`,
  };
  const liveTV_id = "livetv-tak";
  const title = "TAK 360 Live TV";
  const description = `
<div class=" mt-3 justify-center ">
  <h2 class="text-xl font-bold text-gray-700 ">तक 360 लाइव टीवी :</h2>
  <p class="text-gray-700 bold ">
   Tak 360 इंडिया टुडे ग्रुप का प्रतिष्ठित और भरोसेमंद डिजिटल न्यूज प्लेटफॉर्म है. Tak चैनल्स अपनी बेबाक, निष्पक्ष और तेज पत्रकारिता के लिए जाना जाता है. 
   हिंदी न्यूज के क्षेत्र में मजबूत पहचान बना चुका Tak चैनल्स अब अपने दर्शकों के लिए 24 घंटे का न्यूज चैनल लेकर आ रहा है.
    इसमें आपको देश के हर कोने से दिनभर की बड़ी ब्रेकिंग न्यूज, राजनीतिक हलचल, सत्ता और विपक्ष की अंदरूनी खबरें, राज्यों की विधानसभाओं से लेकर लोकसभा के गलियारों तक की एक्सक्लूसिव जानकारी देखने को मिलेगी.
     इसके अलावा हिंदी राज्यों में बड़े क्राइम, डवलपमेंटल इश्यू, वहां की सियासत की खबरें भी आप देख सकते हैं.  स्पोर्ट्स, एंटरटेन्मेंट और बिजनेस की बड़ी खबरें भी आप यहां देख सकते हैं. 
      इसके साथ ही सोशल मीडिया पर वायरल वीडियो और दावों की सच्चाई, विकास से जुड़ी अहम रिपोर्ट्स और जनहित से जुड़े मुद्दों पर गहराई से विश्लेषण भी 360 Tak का हिस्सा होगा. 
       यूं कहें तो सिंगल प्लेटफॉर्म Tak 360 में आप 'गली से ग्लोब' तक जुड़ सकते हैं. 
  </p>
   <h2 class="text-xl font-semibold text-gray-700 ">कहां देख सकते हैं?:</h2>
 <p class="text-gray-700 bold ">दर्शक इसे NewsTak की वेबसाइट newstak.in और YouTube चैनल, आजतक की वेबसाइट aajtak.in, गुड न्यूज टुडे की वेबसाइट gnttv.com, इंडिया टुडे की वेबसाइट indiatoday.in  पर 24×7 देख सकते हैं. </p>
  <h2 class="text-xl font-semibold text-gray-700 ">Tak 360 Channel Features :</h2>
  <p class="text-gray-700 bold ">
    Tak 360 बड़े घटनाक्रमों की लाइव कवरेज और ट्रेंडिंग न्यूज पर खास फोकस करता है. देश-दुनिया में हो रही हर अहम हलचल को तेजी, सटीक और भरोसे के साथ दर्शकों तक पहुंचाना ही News Tak की पहचान है. तथ्यपरक खबर, सटीक विश्लेषण News Tak को बनाते हैं भरोसे का नाम.
  </p>

  <h2 class="text-xl font-semibold text-gray-700 ">Tak 360 पर आने वाले मुख्य Show :</h2>
  <ul class="list-decimal list-inside  text-gray-700 bold space-y-1">
    <li>मुद्दे की बात</li>
    <li>शम्स की जुबानी</li>
    <li>ग्लोबल रिपोर्ट</li>
    <li>हिंदी प्रदेश</li>
    <li>क्राइम रिपोर्ट</li>
    <li>इंटरनेशनल रिपोर्ट</li>
    <li>नेशनल एंड बिजनेस रिपोर्ट</li>
    <li>एस्ट्रोलॉजी</li>
    <li>पॉडकास्ट</li>
    <li>एंटरटेन्मेंट</li>
    <li>जॉब</li>
    <li>सरकारी योजनाएं</li>
    <li>फाइनेंस</li>
    <li>सक्सेज स्टोरीज</li>
  </ul>

   <h2 class="text-xl font-semibold text-gray-700 ">इस टाइम फ्रेम में देख सकते हैं 360:</h2>
  <ul class="list-decimal list-inside  text-gray-700 bold space-y-1">
    <li>6:00 AM-7:00AM: नेशनल एंड बिजनेस रिपोर्ट</li>
    <li>7:00 AM-7:30 AM बजे: राशिफल</li>
    <li>7:30 AM-8:00 AM 360 हेडलाइंस</li>
    <li>8:00 AM-8:30 AM एस्ट्रो बर्थडे</li>
    <li>8:30 AM-9:00 AM 360 हेडलाइंस</li>
    <li>9:00 AM-9:30 AM 360 हेडलाइंस</li>
    <li>9:30 AM-10:00 AM ग्लोबल रिपोर्ट</li>
    <li>10:00 AM-10:30 AM इंटरनेशनल रिपोर्ट</li>
    <li>10:30 AM-11:00 AM हिंदी प्रदेश </li>
    <li>11:00 AM-11:30 AM शम्स की जुबानी</li>
    <li>11:30 AM-12:00 PM क्रइम रिपोर्ट</li>
    <li>12:00 PM-12:30 PM लाइव</li>
    <li>12:30 PM-1:00 PM एंटरटेन्मेंट</li>
    <li>1:00 PM-2:00 PM  पॉडकॉस्ट </li>
    <li>2:00 PM-2:30 PM लाइव</li>
    <li>2:30 PM-3:00 PM चर्चित चेहरा</li>
    <li>3:00 PM-4:00 PM 360 न्यूज</li>
    <li>4:00 PM-4:30 PM लाइव</li>
    <li>4:30PM-5:00PM पर्सनल फाइनेंस एंड जॉब</li>
    <li>5:00PM-5:30 PM हिंदी प्रदेश</li>
    <li>5:30 PM-6:00 PM क्राइम रिपोर्ट</li>
    <li>6:00 PM-6:30 PM 360 हेडलाइंस</li>
    <li>6:30 PM-7:00 PM मुद्दे की बात </li>
    <li>7:00 PM-7:30 PM शम्स की जुबानी</li>
     <li>7:30 PM-8:00 PM ग्लोबल रिपोर्ट</li>
      <li>8:00 PM-8:30 PM 360 हेडलाइंस</li>
       <li>8:30 PM-9:00 PM हिंदी प्रदेश</li>
        <li>9:00 PM-9:30PM क्राइम रिपोर्ट</li>
         <li>9:30PM-10:00PM इंटरनेशनल रिपोर्ट</li>
          <li>10:00PM-11:00 PM नेशल एंड बिजनेस रिपोर्ट</li>
           <li>11:00 PM-11:30 PM 360 हेडलाइंस</li>
            <li>11:30 PM-12:00 AM राशिफल (रात्रि)</li>
             <li>12:00 AM-12:30 AM 360 हेडलाइंस</li>
              <li>12:30 AM-1:00 AM मुद्दे की बात</li>
               <li>1:00 AM-1:30 AM शम्स की बात</li>
                <li>1:30 AM-2:00 AM ग्लोबल रिपोर्ट</li>
              <li>2:00 AM-2:30 AM 360 हेडलाइंस</li>
               <li>2:30 AM-3:00 AM हिंदी प्रदेश</li>
                <li>3:00 AM-3:30 AM क्राइम रिपोर्ट</li>
              <li>3:30 AM-4:00 AM इंटरनेशनल रिपोर्ट</li>
               <li>4:00 AM-5:00 AM नेशनल एंड बिजनेस रिपोर्ट</li>
                <li>5:00 AM-5:30 AM 360 हेडलाइंस</li>
                 <li>5:30 AM-6:00 AM राशिफल</li>
                   
  </ul>

  <h2 class="text-xl font-semibold text-gray-700 ">Digital and Social Media Presence of Tak 360:</h2>
  <p class="text-gray-700 bold mb-6">
    Tak 360 चैनल की सबसे अच्छी बात ये है कि आज के डिजिटल युग में दर्शक और उनकी रुचि को ध्यान में रखते हुए वीडियो न्यूज को फेसबुक, X और इंस्टाग्राम चैनल पर भी प्रसारित किया जाता है. इसके अलावा हिंदी राज्यों की बड़ी खबरें, ब्रेकिंग न्यूज और आम आदमी के काम की खबर के साथ Website (Hindi News, हिंदी न्यूज़, Hindi Samachar, हिंदी समाचार, Latest News in Hindi, Breaking News in Hindi, ताजा ख़बरें, News Tak News) पर शानदार तरीके से उपलब्ध कराया है.
  </p>

  
</div>
`;

  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <LiveTVPage
          isMobileDevice={isMobileDevice}
          metaDescription={metaDesc}
          liveTV_id={liveTV_id}
          title={title}
          description={description}
          faqData={faqData}
          storyPageData={storyPageData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getLatestContentFeed, getContentByType } = await import(
      "@/handlers/content"
    );
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    const faqRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "sample-faqs" },
    });
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: page,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    const videosRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "video",
      },
    });

    const storiesRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "story",
      },
    });

    let [faqData, latestStoryData, latestVideoData, storyPageData] =
      await Promise.all([
        fetchRedisWrapper(faqRedisKey, () =>
          getFaqBySlug({
            url: url, // 'Tak360-livetv', //"kumbha-faq",
          })
        ),
        fetchRedisWrapper(latestStoryRedisKey, () =>
          getLatestContentFeed({
            type: "story",
            page: 0,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(latestVideoRedisKey, () =>
          getLatestContentFeed({
            type: "video",
            page: page,
            display: 5,
            unixtime,
          })
        ),
        fetchRedisWrapper(videosRedisKey, () =>
          getContentByType({
            type: "video",
            page: page,
            display: 12,
          })
        ),
        fetchRedisWrapper(storiesRedisKey, () =>
          getContentByType({
            type: "story",
            page: page,
            display: 12,
          })
        ),
      ]);

    let headerCache = storyPageData?.cache;

    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        latestStoryData,
        latestVideoData,
        faqData,
        storyPageData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
